import { maxBreakpoints, minBreakpoints, theme } from '@noths/polaris-client-ribbons-base';
import { mediaQuery } from '@noths/polaris-client-styles';
import { css } from 'styled-components';
var fonts = theme.fonts,
  spacing = theme.spacing;
var verticalMiddle = /*#__PURE__*/css(["margin:auto 0;"]);
export var header = /*#__PURE__*/css(["position:relative;text-align:center;font-family:", ";border-bottom:1px solid var(--neutral-black-30);padding:", "px ", "px;", ";", ";"], fonts.PRIMARY_SEMIBOLD.family, spacing.sm, spacing.xs, mediaQuery({
  min: minBreakpoints.M,
  max: maxBreakpoints.M
}, css(["padding:", "px ", "px ", "px ", "px;border-bottom:0 none;"], spacing.md, spacing.xl, spacing.sm, spacing.xl)), mediaQuery({
  min: minBreakpoints.L
}, css(["padding:", "px ", "px ", "px ", "px;border-bottom:0 none;"], spacing.md, spacing.xl, spacing.sm, spacing.xl)));
export var headerInner = function headerInner(searchBarVisible) {
  return css(["max-width:", "px;margin:0 auto;display:grid;", ";", ";", ";", ";"], minBreakpoints.XL, mediaQuery({
    min: minBreakpoints.M
  }, css(["grid-template-columns:1fr 42% 1fr;grid-template-areas:'siteLogo searchBar iconBar';"])), mediaQuery({
    min: minBreakpoints.L
  }, css(["grid-template-columns:1fr 33% 1fr;"])), mediaQuery({
    min: minBreakpoints.XL
  }, css(["grid-template-columns:1fr 46% 1fr;"])), mediaQuery({
    max: maxBreakpoints.S
  }, css(["grid-template-areas:'siteLogo iconBar' 'searchBar searchBar';row-gap:", "px;"], searchBarVisible ? spacing.sm : 0)));
};
export var siteLogo = /*#__PURE__*/css(["", " grid-area:siteLogo;display:flex;", ";"], verticalMiddle, mediaQuery({
  max: maxBreakpoints.M
}, css(["margin-left:8px;"])));
export var searchBarContainer = /*#__PURE__*/css(["", " grid-area:searchBar;"], verticalMiddle);
export var searchBarContainerHidden = /*#__PURE__*/css(["", ";"], mediaQuery({
  max: maxBreakpoints.S
}, css(["display:none;"])));
export var iconBar = /*#__PURE__*/css(["", " grid-area:iconBar;justify-self:end;"], verticalMiddle);